import { lt } from '@mews/framework';
import { useRepositorySuspenseQuery } from '@mews-commander/data-access';
import { PaymentLinkDetailItem } from './PaymentLinkDetailItem';

export const PaymentTypeInfoRow = ({ paymentId }: { paymentId: string }) => {
    const {
        data: { details },
    } = useRepositorySuspenseQuery('paymentDetails', 'get', { paymentId });

    return <PaymentLinkDetailItem description={lt('Payment')} value={details.title} />;
};
